<template>
  <div class="d-flex flex-column">
    <div class="pa-2 pl-0 text-subtitle-2 text-label"> {{ field.name }}: </div>
    <div class="pa-2 pt-0 full-width">
      <v-slide-group show-arrows>
        <v-slide-item v-for="(slide, i) in value" :key="i">
          <v-sheet tile class="pa-2">
            <div
              class="d-flex flex-wrap align-center"
              v-for="x in fields"
              :key="x.code"
            >
              <div class="px-2 pl-0 text-subtitle-2 text-label">
                {{ x.name }}
              </div>
              <div class="px-2">{{ getValue(x, slide) }}</div>
            </div>
          </v-sheet>
        </v-slide-item>
      </v-slide-group>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  components: {},
  props: {
    field: { type: Object, required: true },
    value: { type: Array, required: true },
  },
  computed: {
    fields() {
      return this.field.meta.field.fields.filter(
        (x) => !x.visibility || x.visibility.browse
      )
    },
  },
  methods: {
    getValue(field, value) {
      return get(value, field.code || field.name)
    },
  },
}
</script>

<style scoped>
.text-label {
  font-weight: 700;
}
</style>
